import styled from "styled-components";
import { Link } from "react-router-dom";
export const CardContainer = styled.div``;

export const SideBar = styled.div`
  width: 20%;
  height: 100vh;
  background: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
`;

export const SideList = styled(Link)`
  text-decoration: none;
  // flex-grow: 1;
  padding: 15px;
  font-size: 2.2rem;
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;

  div {
    color: #000;
  }
`;
export const CardDetails = styled.section`
  position: absolute;
  top: 3rem;
  left: 15rem;
`;

export const CardContent = styled.div`
  display: flex;
  justify-content: center;
  align-item: center;
`;

// export const CardQuantity = styled.p`
//   font-weight: bold;
//   font-size: 3rem;
// `;

// export const CardName = styled.p`
//   font-size: 20px;
//   font-weight: bold;
//   color: #3cc830;
// `;
